import { rssiClass, rssiRatio } from '../format';

export function RssiBar({ dbm }: { dbm: number }) {
  const pct = Math.round(rssiRatio(dbm) * 100);
  return (
    <div className="rssi" title={`${dbm} dBm`}>
      <div className="rssi__track">
        <div className={`rssi__fill rssi__fill--${rssiClass(dbm)}`} style={{ width: `${pct}%` }} />
      </div>
      <span className="rssi__value">{dbm} dBm</span>
    </div>
  );
}
